/*
 * <editorial-reviews>: FW26 home "What customers say" (sections/editorial-reviews.liquid).
 * Fetches real Judge.me reviews from the loyalty App Proxy once the section is near the
 * viewport, keeps the newest ones that meet the minimum rating and carry a real title, and
 * reveals the section. Anything else (network error, timeout, nothing qualifies) leaves the
 * section hidden: no placeholder reviews, ever. All review text goes in via textContent.
 * Reviews written in the page's language come first (a small stop-word check; the proxy sends
 * no language), newest first within each group. Names typed all in capitals or all in lower
 * case are shown in title case ("LINDA K" -> "Linda K.").
 */
(function () {
  if (customElements.get('editorial-reviews')) return;

  var TIMEOUT_MS = 20000;
  var PER_PAGE = 60;

  // "LINDA" / "linda" -> "Linda"; mixed case ("McKay", "de la Cruz") is left as typed.
  function tidyWord(word) {
    return word.replace(/\p{L}+/gu, function (seg) {
      var upper = seg === seg.toUpperCase();
      var lower = seg === seg.toLowerCase();
      if (upper === lower || (!upper && !lower)) return seg;
      return seg.charAt(0).toUpperCase() + seg.slice(1).toLowerCase();
    });
  }

  function firstNameInitial(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '';
    var first = tidyWord(parts[0]);
    if (parts.length === 1) return first;
    var last = parts[parts.length - 1].replace(/[^\p{L}]/gu, '');
    return last ? first + ' ' + last.charAt(0).toUpperCase() + '.' : first;
  }

  var STOP_WORDS = {
    en: 'the and is it very this my was for with so are love great they fit',
    de: 'und ich ist sehr die der das nicht mit für sie es ein eine auch war gut schön',
    fr: 'et je est très le les pas avec pour une qualité elle il',
    it: 'e è molto il non con per una che bella ottima',
    es: 'y es muy el los con para una que bonito calidad',
    nl: 'en ik zeer heel het niet met voor een mooi erg'
  };

  function language(r) {
    var words = (String(r.title || '') + ' ' + String(r.body || '')).toLowerCase().split(/[^\p{L}]+/u);
    var best = '';
    var bestScore = 0;
    Object.keys(STOP_WORDS).forEach(function (lang) {
      var list = ' ' + STOP_WORDS[lang] + ' ';
      var score = words.filter(function (w) { return w && list.indexOf(' ' + w + ' ') >= 0; }).length;
      if (score > bestScore) {
        best = lang;
        bestScore = score;
      }
    });
    return best;
  }

  // Judge.me stores emoji as text shortcodes ("wonderful:heart:", "recommend:clap::skin-tone-3:").
  // Show the ones listed here as emoji and drop any other shortcode: a long one is a single
  // unbreakable word that used to push the card, and with it the whole page, wider than a phone.
  // A name needs a letter (or is +1 / 100), so a time like "10:30:45" is left alone.
  var EMOJI = {
    heart: '❤️', heavy_black_heart: '❤️', hearts: '♥️',
    heavy_heart_exclamation_mark_ornament: '❣️', heart_exclamation: '❣️',
    two_hearts: '💕', sparkling_heart: '💖', heartpulse: '💗', heartbeat: '💓',
    revolving_hearts: '💞', gift_heart: '💝', blue_heart: '💙', green_heart: '💚',
    yellow_heart: '💛', purple_heart: '💜',
    heart_eyes: '😍', smiling_face_with_heart_eyes: '😍', smiling_face_with_3_hearts: '🥰',
    smiling_face_with_three_hearts: '🥰', kissing_heart: '😘', star_struck: '🤩',
    blush: '😊', smile: '😄', smiley: '😃', grinning: '😀', grin: '😁',
    laughing: '😆', joy: '😂', sweat_smile: '😅', relaxed: '☺️',
    slightly_smiling: '🙂', slightly_smiling_face: '🙂', wink: '😉', innocent: '😇',
    sunglasses: '😎', hugs: '🤗', hugging_face: '🤗',
    '+1': '👍', thumbsup: '👍', clap: '👏', pray: '🙏', raised_hands: '🙌',
    ok_hand: '👌', muscle: '💪', wave: '👋',
    star: '⭐', star2: '🌟', sparkles: '✨', fire: '🔥', '100': '💯',
    white_check_mark: '✅', heavy_check_mark: '✔️', tada: '🎉', gift: '🎁',
    package: '📦', truck: '🚚', rose: '🌹', cherry_blossom: '🌸',
    snowflake: '❄️', christmas_tree: '🎄', rainbow: '🌈', crown: '👑', gem: '💎'
  };
  var SHORTCODE = /:(\+1|100|(?=[a-z0-9_-]{0,59}[a-z])[a-z0-9_-]{1,60}):(?::skin-tone-([2-6]):)?️?/g;

  function cleanText(s) {
    return String(s || '')
      .replace(SHORTCODE, function (m, name, tone) {
        var emoji = EMOJI[name];
        if (!emoji) return '';
        // Skin tones 2-6 are the modifiers U+1F3FB-U+1F3FF, written straight after the base emoji.
        return tone ? emoji.replace(/️/g, '') + String.fromCodePoint(0x1f3f9 + Number(tone)) : emoji;
      })
      .replace(/[ \t]{2,}/g, ' ')
      .trim();
  }

  // Judge.me fills an empty title with the start of the body ("Very good, just what I").
  // That is not a title the customer wrote, so it does not qualify.
  function realTitle(r) {
    var t = String(r.title || '').trim();
    if (!t) return '';
    var body = String(r.body || '').trim();
    if (body && body.length > t.length && body.toLowerCase().indexOf(t.toLowerCase()) === 0) return '';
    return t;
  }

  function isVerified(r) {
    var v = r && r.verified;
    return v === true || v === 'buyer' || v === 'verified_buyer';
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  class EditorialReviews extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;
      this.list = this.querySelector('[data-reviews-list]');
      if (!this.list) return;
      var start = this.load.bind(this);
      if (!('IntersectionObserver' in window)) return start();
      // The element is display:none while hidden, so observe the section wrapper instead.
      var target = this.closest('.shopify-section') || this.parentElement;
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          start();
        }
      }, { rootMargin: '800px 0px' });
      io.observe(target);
    }

    load() {
      var self = this;
      var d = this.dataset;
      var url = d.endpoint + '?scope=' + encodeURIComponent(d.scope || 'products') + '&per_page=' + PER_PAGE + '&page=1';
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (timer) clearTimeout(timer);
          self.render((data && data.reviews) || []);
        })
        .catch(function () {
          if (timer) clearTimeout(timer);
          self.fail();
        });
    }

    pick(reviews) {
      var min = parseInt(this.dataset.minRating, 10) || 5;
      var count = parseInt(this.dataset.count, 10) || 3;
      var pageLang = String(document.documentElement.lang || '').toLowerCase().split('-')[0];
      if (!STOP_WORDS[pageLang]) pageLang = '';
      var seen = {};
      reviews = reviews.map(function (r) {
        return r ? Object.assign({}, r, { title: cleanText(r.title), body: cleanText(r.body) }) : r;
      });
      return reviews
        .filter(function (r) {
          if (!r || Number(r.rating) < min) return false;
          if (!realTitle(r) || !firstNameInitial(r.name)) return false;
          // The same text can be attached to two products (merged listings); show it once.
          var key = (realTitle(r) + '|' + String(r.body || '').trim()).toLowerCase();
          if (seen[key]) return false;
          seen[key] = true;
          return true;
        })
        .sort(function (a, b) {
          var pa = pageLang && language(a) === pageLang ? 0 : 1;
          var pb = pageLang && language(b) === pageLang ? 0 : 1;
          if (pa !== pb) return pa - pb;
          return (Date.parse(b.createdAt) || 0) - (Date.parse(a.createdAt) || 0);
        })
        .slice(0, count);
    }

    render(reviews) {
      var picked = this.pick(reviews);
      if (!picked.length) return this.fail();
      var d = this.dataset;
      var showBody = d.showBody === 'true';
      var frag = document.createDocumentFragment();
      picked.forEach(function (r) {
        var rating = Math.round(Number(r.rating));
        var li = el('li', 'ed-review');
        var fig = el('figure', 'ed-review__figure');

        var stars = el('p', 'ed-review__stars');
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', (d.labelRating || 'Rated [rating] out of 5').replace('[rating]', rating));
        var glyphs = el('span', null, '\u2605\u2605\u2605\u2605\u2605'.slice(0, rating) + '\u2606\u2606\u2606\u2606\u2606'.slice(0, 5 - rating));
        glyphs.setAttribute('aria-hidden', 'true');
        stars.appendChild(glyphs);
        fig.appendChild(stars);

        var quote = el('blockquote', 'ed-review__quote');
        quote.appendChild(el('p', 'ed-review__title', '\u201c' + realTitle(r) + '\u201d'));
        var body = String(r.body || '').trim();
        if (showBody && body) quote.appendChild(el('p', 'ed-review__body', body));
        fig.appendChild(quote);

        var cap = el('figcaption', 'ed-review__meta');
        var bits = [firstNameInitial(r.name)];
        if (isVerified(r) && d.labelVerified) bits.push(d.labelVerified);
        bits.push((d.labelStars || '[rating] stars').replace('[rating]', rating));
        cap.appendChild(el('span', 'ed-review__who', bits.join(' \u00b7 ')));
        fig.appendChild(cap);

        li.appendChild(fig);
        frag.appendChild(li);
      });
      this.list.textContent = '';
      this.list.appendChild(frag);
      this.hidden = false;
    }

    fail() {
      // Stay hidden on the storefront. In the theme editor, say why the section is empty.
      if (!('designMode' in this.dataset)) return;
      this.list.textContent = '';
      this.list.appendChild(el('li', 'ed-review ed-review--note', 'No qualifying reviews were returned by /apps/loyalty/reviews, so this section is hidden on the storefront.'));
      this.hidden = false;
    }
  }

  customElements.define('editorial-reviews', EditorialReviews);
})();
